import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import type { ThunkAction } from '../../types';

export function getVisibilityTypes(): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/reference-layers/settings/visibility-types';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId
      }
    };

    return makeAPICall(endpoint, options, true).then(
      response => {
        dispatch({
          type: 'UPDATE_VISIBILITY_TYPES',
          visibilityTypes: response.data.visibilityTypes
        });
      },
      error => dispatch(APIError(error, 'Error getting visibility types'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/referenceLayers/visibilityType.js